import { Button, mergeClasses } from '@fluentui/react-components';
import React from 'react';
import { useCarouselListBuiltInNavStyles } from './CarouselListBuiltInNavControl.styles';
export var CarouselListBuiltInNavControl = function (_a) {
    var ariaLabel = _a.ariaLabel, onClick = _a.onClick, icon = _a.icon, navDirection = _a.navDirection, title = _a.title;
    var styles = useCarouselListBuiltInNavStyles();
    return (React.createElement("div", { className: navDirection === 'next'
            ? mergeClasses(styles.container, styles.containerNext)
            : styles.container },
        React.createElement(Button, { "aria-label": ariaLabel, "aria-disabled": "false", className: styles.button, onClick: onClick, icon: icon, title: title })));
};
//# sourceMappingURL=CarouselListBuiltInNavContol.js.map